import React, {useEffect, useState} from 'react';
import localization from "../../../../assets/localization/localization";
import Layout from 'components/sales/layout/layout';
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import {Button} from "react-bootstrap";
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import CustomModal from "../../../valetServices/modal";
import {toast} from "react-toastify";

const SiteRepositoryFinance = (
    {
        match,
        documentUploadUrlPublic,
        documentUrlDataPublic,
        siteRepository,
        getSiteRepository,
        getSiteRepositoryFianance,
        getSiteRepositoryDetails,
        createSiteRepository
    }
) => {


    const [isLoading, setIsLoading] = useState(false);
    const [inputImage, setImageList] = useState([{url: "", content: ""}]);
    const [siteTypeImage, setSiteTypeImage] = useState(
        [
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}, {url: "", content: ""},
            {url: "", content: ""}, {url: "", content: ""}
        ]
    );
    const [listData, setRepositoryData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [count, setCount] = useState(0)
    const [fileExt, setFileExt] = useState("")

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            getSiteRepositoryFianance(match.params.comm_id);
            setIsLoading(false)
        })()
    }, [])

    const headers = ['Media', 'Description', 'Created On'];

    useEffect(() => {
        const tableData = ['doc_type', 'description', 'created_at'];
        if (getSiteRepositoryDetails && Object.keys(getSiteRepositoryDetails).length > 0) {
            setSiteTypeImage([])
            if (getSiteRepositoryDetails?.required_document) {
                setSiteTypeImage(getSiteRepositoryDetails?.required_document)
            }

            const data = getSiteRepositoryDetails?.data.map((element) =>

                Object.assign(
                    {},
                    ...tableData.map((key) => (
                        key === 'doc_type' && element[key] === 'png' ? {
                                [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                    "width": "48px",
                                    "borderRadius": "16px",
                                    "height": "48px"
                                }}/></a>
                            } :
                            key === 'doc_type' && element[key] === 'jpeg' ? {
                                    [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                        "width": "48px",
                                        "borderRadius": "16px",
                                        "height": "48px"
                                    }}/></a>
                                } :
                                key === 'doc_type' && element[key] === 'jpg' ? {
                                        [key]: <a href={element['url']} target="_blank"><img src={element['url']} style={{
                                            "width": "48px",
                                            "borderRadius": "16px",
                                            "height": "48px"
                                        }}/></a>
                                    } :
                                    key === 'doc_type' && element[key] === 'doc' ? {
                                            [key]: <a href={element['url']} target="_blank"><img src={Images?.DocIcon}
                                                                                                 alt=""
                                                                                                 className="view-icon"/></a>
                                        } :
                                        key === 'doc_type' && element[key] === 'pdf' ? {
                                                [key]: <a href={element['url']} target="_blank"><img src={Images?.DocIcon}
                                                                                                     alt=""
                                                                                                     className="view-icon"/></a>
                                            } :
                                            key === 'doc_type' ? {
                                                    [key]: <a href={element['url']} target="_blank"><img
                                                        src={Images?.DocIcon}
                                                        alt=""
                                                        className="view-icon"/></a>
                                                } :
                                                {[key]: element[key]})),
                )
            );
            data && setRepositoryData(data);
            setPageCount(Math.ceil(getSiteRepositoryDetails.total / getSiteRepositoryDetails.per_page));
        }
    }, [getSiteRepositoryDetails]);


    const onPageChange = async (val) => {
        setIsLoading(true);
        getSiteRepository(match.params.id, val.selected + 1);
        setIsLoading(false);
    };

    const handleImageContent = (val, index) => {
        const list = [...inputImage]
        list[index]['content'] = val
        setImageList([...list])
    }

    const saveImage = (val, index) => {
        const list = [...inputImage]
        list[index]['url'] = val
        setImageList([...list])
    }

    const handleSiteTypeImageContent = (val, index) => {
        const list = [...siteTypeImage]
        list[index]['content'] = val
        setSiteTypeImage([...list])
    }

    const saveSiteTypeImage = (val, index) => {
        const list = [...siteTypeImage]
        list[index]['url'] = val
        setSiteTypeImage([...list])
    }

    const handleImageAdd = () => {
        setImageList(
            [
                ...inputImage, {
                url: '',
                content: ''
            }
            ]
        )
    }

    const handleImageRemove = index => {
        const list = [...inputImage];
        list.splice(index, 1);
        setImageList(list);
    }

    const handleSubmit = async () => {
        let isBroken = false;
        siteTypeImage.map((x, i) => {
            if (x?.url === "" && !isBroken && x?.content !== 'Videos') {
                // toast.error("Document is required for " + x?.content);
                // isBroken = true
            }
        })

        if (isBroken) {
            return false
        }

        let data = {
            'site_id': match.params.id,
            'image_url': inputImage,
            'required_document': siteTypeImage
        }

        setIsLoading(true)
        let res = await siteRepository(data)
        setCount(count + 1)
        setIsLoading(false)
    }

    return (
        <Layout
            title={localization.siteRepository}
            isLoading={isLoading}
            isGoback={true}
        >
            <>
                <div className="container-fluid">
                    <div className="card mt-2">
                        <div className="card-header">
                            {localization.siteRepositoryListing}
                        </div>
                        <div className="card-header">
                            <div className="card-body">
                                <TableSection
                                    data={listData}
                                    isId={false}
                                    isMngId={false}
                                    headers={headers}
                                    pageCount={pageCount}
                                    onPageChange={onPageChange}
                                    onChange={() => {
                                    }}
                                    detailList={listData && listData}
                                    srNo={getSiteRepositoryDetails?.from}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </Layout>
    )
}

export default SiteRepositoryFinance